<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="knowledge-base-page" class="relative">

    <div class="page_header_wrap" :class="{ filters_open: filtersList }">
      <div class="page_header">
          <div>
            <h2 ><a><img src="@/assets/images/pages/arrow.png"></a>Knowledge Base</h2>
          </div>
          <div class="page_actions">
            <button v-if="activeUserInfo.roleId == 1"  class="secondary_btn add" @click="add()">
            Add To knowledge base 
            </button>
            <button  class="secondary_btn filters_btn" :class="{ active: filtersList }" @click="filtersList = !filtersList">
              <span class="material-icons"> filter_list</span>Filters
            </button>
          </div>
        </div> 
        <div class="filter_layer" @click="filtersList = !filtersList"></div>
          <div
     ref="filterCard"
      title="Filters knowledge-base"
      class="user-list-filters filters_list"
      actionButtons 
  >
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">Device Family</label>
            <multiselect
            :multiple="true" 
            label="name"
            track-by="name"
            placeholder="Select"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            v-model="filters.deviceFamIds" :options="deviceFamily" >
              <template slot="selection" slot-scope="{ values, isOpen }">
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && !isOpen"
                  >{{ values.length }} Device Family(s) selected</span
                >
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && isOpen"
                ></span>
              </template>
              <span slot="noResult">No Device Families Found</span>
            </multiselect>
        </div>        
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">Area</label>
            <multiselect
            :multiple="true" 
            label="name"
            track-by="name"
            placeholder="Select"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            v-model="filters.areaIds" :options="Areas" >
               <template slot="selection" slot-scope="{ values, isOpen }">
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && !isOpen"
                  >{{ values.length }} Area(s) selected</span
                >
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && isOpen"
                ></span>
              </template>
              <span slot="noResult">No Areas Found</span>
            </multiselect>
        </div>        
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">Type</label>
            <multiselect
            :multiple="true" 
            label="name"
            track-by="name"
            placeholder="Select"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            v-model="filters.typeIds" :options="types" >
            <template slot="selection" slot-scope="{ values, isOpen }">
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && !isOpen"
                  >{{ values.length }} Type(s) selected</span
                >
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && isOpen"
                ></span>
              </template>
              <span slot="noResult">No Types Found</span>
            </multiselect>
        </div>
        
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
          <label class="text-sm opacity-75">Created Date</label>
          <date-range-picker :autoApply="autoApply" :ranges="false" :opens="'left'" :maxDate="maxDate"
            v-model="selected_createdDateRange"></date-range-picker>
        </div>

      <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10">
        <label class="text-sm opacity-75">Search</label>
          <input
           v-model="filters.title"
            class="search_field"
            type="text"
            @keyup.enter="onEnter"
            placeholder="Search By Title"
          />
        </div>

        <div class="vx-col md:w-3/4   w-full d-flex align-end justify-end marb10" >
          <button @click="clearFilters()" class="secondary_btn">
            Clear
          </button>
          <button class="primary_btn marl15" @click="get_list() , filtersList = !filtersList">
            Apply 
          </button>
        </div>
        <!-- <div
          class="vx-col md:w-1/4 sm:w-1/2 w-full d-flex justify-end align-end"
        >
          <button class="secondary_btn add" @click="add()">
          Add knowledge
          </button>
        </div> -->
      </div>
    </div>
    </div> 

  
    
   <!-- <vs-table :data="list">
      <template slot="thead">
        <vs-th> Title </vs-th>
        <vs-th> Created on </vs-th>
        <vs-th> Action </vs-th>
      </template>-->
      <vs-table v-model="selected" noDataText="" :data="list" >
      <template slot="thead">
        <vs-th> 
        <a  @click="sortMe('title')" v-bind:class="{
                  sort_ascending: sortKeys['title'] == 1,
                  sort_descending: sortKeys['title'] != 1,
                }"
                > Title</a>
         </vs-th>
         <vs-th><a  @click="sortMe('deviceFamName')" v-bind:class="{
                  sort_ascending: sortKeys['deviceFamName'] == 1,
                  sort_descending: sortKeys['deviceFamName'] != 1,
                }"
                > Device Type</a>
                </vs-th>
           <vs-th>
           <a  @click="sortMe('typeName')" v-bind:class="{
                  sort_ascending: sortKeys['typeName'] == 1,
                  sort_descending: sortKeys['typeName'] != 1,
                }"
                >
           Type
           </a>
           </vs-th>
          <vs-th>
            <a  @click="sortMe('areaName')" v-bind:class="{
                    sort_ascending: sortKeys['areaName'] == 1,
                    sort_descending: sortKeys['areaName'] != 1,
                  }"
                  >
            Area
            </a>
          </vs-th>
        <vs-th> 
        <a  @click="sortMe('createdOn')" v-bind:class="{
                  sort_ascending: sortKeys['createdOn'] == 1,
                  sort_descending: sortKeys['createdOn'] != 1,
                }"
                > Created on</a>
               
        </vs-th>
         <vs-th class="w-80">
          Action
        </vs-th>  
      </template>

      <template  v-for="(knowledge ,index) in list" >
        <vs-tr :key="index">
          <vs-td> {{knowledge.title}}</vs-td>
           <vs-td>
            
              <template v-if="ckeckValue(knowledge ,'deviceFamDetails')">
                         {{knowledge.deviceFamDetails.name}}
             </template>
             
           
              </vs-td>
           <vs-td>
             <template v-if="ckeckValue(knowledge ,'typeDetails')">
                        {{knowledge.typeDetails.name}}
             </template>
             
              
              </vs-td>

            <vs-td>
              <template v-if="ckeckValue(knowledge ,'areaDetails')">
                        {{knowledge.areaDetails.name}}
              </template>
              
            
            </vs-td>
           
          
          <vs-td> {{knowledge.createdOn | formatDate}} 
            <br>
              <small>{{ knowledge.createdOn | formatTime}}</small>   
          </vs-td>
          <vs-td>
            <vs-dropdown vs-trigger-click>
              <a class="a-icon" href.prevent> 
                <span class="material-icons">more_vert</span>
              </a>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="getDetails( knowledge,true)"><span>Edit</span></vs-dropdown-item>
                <vs-dropdown-item>
                  <router-link
                      :to="'/knowledge-details/'+knowledge['_id']"
                    ><span>View</span></router-link>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <!-- <span @click="getDetails( knowledge,true)" class="td_edit"
              ><img src="@/assets/images/pages/edit.png" />Edit</span>
              <router-link class="primary_btn approve_btn"
                      :to="'/knowledge-details/'+knowledge['_id']"
                    >View</router-link> -->
          </vs-td>
          <!-- <vs-td>
            <span @click="getDetails( knowledge,true)" class="td_edit" 
              >View</span     >-->
                  <!-- <router-link
                      :to="'/knowledge-details/'+knowledge['_id']"
                    >View</router-link> 
          </vs-td>-->
        </vs-tr>
      </template>
      <template v-if="list.length<=0">
          <tr>
            <td colspan="6" class="center-align">No knowledge bases Found!</td>
          </tr>
        </template>
        
    </vs-table>
    <div class="pagination_wrap">
      <div class="pagination_content" v-if="totalpages > 0">
        <h6>Show Records</h6>
        <multiselect
          :multiple="false" 
            @input="change_perPage()"
          placeholder="Page"
          
          :close-on-select="true"
          :clear-on-select="false"
          :hide-selected="true"
          :preserve-search="true"
          v-model="perPage" :options="perPeges" >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            
        </multiselect>
      </div>
      <vs-pagination
      :total="totalpages"
      :max="7"
      v-model="page"
      @input="callFromSort  = true;get_list()"
      />
    </div>


    <vs-popup v-if="popupcreateticket"
      class="holamundo"
      :active.sync="popupcreateticket"
      :title="!popupeditKnowledgeBase?'Add':'Edit'"
    >
      <div class="createticket_form form_section">
        <form autocomplete="off">
           <ul>
            <li>
              <div class="form-group">
              <lable class="form_label">Title*</lable>
              <vs-input
                v-validate="'required'"
                
                name="Title"
                icon-no-border
                icon-pack="feather" 
                v-model="newKnowledge.title"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first("Title")
              }}</span>
              </div>
            </li>
            <li>
              <div class="form-group">
              <lable class="form_label">Bug*</lable>
              <vs-input
                name="Bug"
                v-validate="'required'"
                icon-no-border
                icon-pack="feather" 
                v-model="newKnowledge.bug"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first("Bug")
              }}</span>
              </div>
            </li>
            
             <li>
             <!-- <vs-input
                v-validate="'required'"
                data-vv-validate-on="blur"
                name="deviceFamId"
                icon-no-border
                icon-pack="feather"
                label-placeholder="deviceFamId"
                v-model="newKnowledge.deviceFamId"
                class="w-full"
              />-->
              <div class="form-group">
              <lable class="form_label">Device Family*</lable>
            <multiselect

            :searchable="true"
            :allow-empty="false"
            :hide-selected="true"
            @input="changedDevice"
            name="deviceFamId"
            :multiple="false" 
            label="name"
            track-by="name" 
             placeholder="Select  Device Family"
            v-model="newKnowledge.deviceFamDetails" :options="deviceFamily" >
             <span slot="noResult">No Device Families Found</span>
            </multiselect>
              <span class="text-danger text-sm">{{
                errors.first("deviceFamId")
              }}</span>
              </div>
            </li>
            
            <li>
              <div class="form-group">
             <label class="form_label">Area*</label>
              <multiselect
            :searchable="true"
            :allow-empty="false"
            :hide-selected="true"
              @input="changedArea"
            v-validate="'required'"  
            name="areaId"
            :multiple="false" 
            label="name"
            track-by="name" 
             placeholder="Select Area"
            v-model="newKnowledge.areaDetails" :options="Areas" >
             <span slot="noResult">No Areas Found</span>
            </multiselect>
              <span class="text-danger text-sm">{{
                errors.first("areaId")
              }}</span>
              </div>
            </li>
             <li>
               <div class="form-group">
              <label class="form_label">Type Details*</label>
            <multiselect
            :searchable="true"
            :allow-empty="false"
            :hide-selected="true"
            @input="changedType"
            v-validate="'required'"
            name="Type"
            :multiple="false" 
            label="name"
            track-by="name"
            placeholder="Select Type"
            v-model="newKnowledge.typeDetails" :options="types" >
             <span slot="noResult">No Type Details Found</span>
            </multiselect>
              <span class="text-danger text-sm">{{
                errors.first("Type")
              }}</span>
               </div>
            </li>

            
            
            <li>
              <!--<vs-input
                v-validate="'required'"
                data-vv-validate-on="blur"
                name="version"
                icon-no-border
                icon-pack="feather"
                label-placeholder="version"
                v-model="newKnowledge.version"
                class="w-full"
              />-->
              <div class="form-group">
              <label class="form_label">Version Details*</label>
            <multiselect
             :searchable="true"
            :allow-empty="false"
            :hide-selected="true"
            @input="changedVersion"
            name="version"
            :multiple="false" 
            label="name"
            track-by="name"
            placeholder="Versions"
            v-model="newKnowledge.versionDetails" :options="versions" >
            <span slot="noResult">No Versions Found</span>
            </multiselect>
              <span class="text-danger text-sm">{{
                errors.first("version")
              }}</span>
              <span class="text-danger text-sm">{{
                errors.first("version")
              }}</span>
              </div>
            </li>
            
            <li>
              <div class="form-group">
              <label class="form_label">Fixed version Details*</label>
            <multiselect

            :searchable="true"
            :allow-empty="false"
            :hide-selected="true"
            @input="changedFxVersion"
            
            name="FixVerDetails"
            :multiple="false" 
            label="name"
            track-by="name"
            placeholder="Versions"
            v-model="newKnowledge.fixVersionDetails" :options="versions" >
            <span slot="noResult">No Versions Found</span>
            </multiselect>
              <span class="text-danger text-sm">{{
                errors.first("version")
              }}</span>
              <span class="text-danger text-sm">{{
                errors.first("FixVerDetails")
              }}</span>
              </div>
            </li>
             
            <li>
              <div class="form-group">
           <label class="form_label">Description*</label>
              <vs-textarea
               v-validate="'required|min:10'"
                v-model="newKnowledge.description"
                label-placeholder="Subject"
                name="Description"
                
              />
              <span class="text-danger text-sm">{{
                errors.first("Description")
              }}</span>
              </div>
            </li>
            <li>
             <div class="form-group">
             <label class="form_label">Documents*</label>
            <div class="files_wrap" @click="documents=[]">
            <file-upload v-model="documents" class="file-upload-input"
            accept="*"  :name="'documents'" data-vv-as="Upload SDK documents"
              :multiple="false" @input="upload(documents)" >
              <img class="file-icon" src="@/assets/images/file-icons/file-upload.svg"> Upload
            </file-upload>
            <span class="text-danger text-sm"
              v-show="errors.has('documents')">{{ errors.first('documents') }}</span>
            </div>
            
              <ul  class="uploaded-list">                
                <li><vs-chip @click="remove(indx)" :name="'sdkdocumentRemoveSelected'" v-for="(other, indx) in newKnowledge.documents" :key="indx"  closable> {{ other.name }} </vs-chip></li>
              </ul>
             </div>
             </li>
             <li>
             <!--<vs-input
                v-validate="'required'"
                data-vv-validate-on="blur"
                name="wrkAround"
                icon-no-border
                icon-pack="feather"
                label-placeholder="Work Around"
                v-model="newKnowledge.wrkAround"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first("wrkAround")
                }}</span>-->
              <!-- <label class="text-sm opacity-75">Work Around </label>
              <input type="checkbox" :value="'yes'" v-model="newKnowledge.wrk_Around" @click="check($event)">  -->
              <vs-checkbox :value="'yes'" v-model="newKnowledge.wrk_Around" @click="check($event)">Work Around</vs-checkbox>
            </li>
             
             
            
           
          </ul>
        </form>
        <div class="form_actions pad0">
          <span></span>
         
          <button
          v-if="!popupeditKnowledgeBase"
          :disabled="validateMe"
            class="close_popup primary_btn"
            @click="create()"
          >
            Create
          </button>
           <button
          v-if="popupeditKnowledgeBase"
          :disabled="validateMe"
            class="close_popup primary_btn"
            @click="update()"
          >
            Update
          </button>
        </div>
      </div>
    </vs-popup>

    
  </div>
</template>

<script>
import vSelect from 'vue-select'
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Multiselect from "vue-multiselect-inv";
import moment from "moment";
import _ from "lodash";
import FileUpload from "vue-upload-component/src";
export default {
  components: {
    vSelect,
    DateRangePicker,
    Multiselect,
    FileUpload
  },
  computed: {
     activeUserInfo () {
      console.log(JSON.stringify(this.$store.state.auth.user));
      return this.$store.state.auth.user
    },
    validateMe () {
     // console.log(JSON.stringify(this.newKnowledge));
      //this.errors.any()
      if( this.errors.any()
      || (  this.newKnowledge.deviceFamId ==null || this.newKnowledge.deviceFamId ==''  )
      || (  this.newKnowledge.typeId ==null || this.newKnowledge.typeId ==''  )
      || (  this.newKnowledge.bug ==null || this.newKnowledge.bug =='' || this.newKnowledge.bug.trim() ==''   )
      || (  this.newKnowledge.areaId ==null || this.newKnowledge.areaId ==''  )
      || (  this.newKnowledge.version ==null || this.newKnowledge.version ==''  ) 
      || (  this.newKnowledge.documents == [] || this.newKnowledge.documents.length == 0 )
      || (  this.newKnowledge.title ==null || this.newKnowledge.title =='' || this.newKnowledge.title.trim() ==''   )
      || (  this.newKnowledge.description ==null || this.newKnowledge.description =='' || this.newKnowledge.description.trim() ==''   )
      || (  this.newKnowledge.fixVersion ==null || this.newKnowledge.fixVersion ==''  )
     
      ){
        let l = "deviceFamId "+this.newKnowledge.deviceFamId +" \n --- "
                +"typeId "+this.newKnowledge.typeId +" \n -- "
               + "bug "+this.newKnowledge.bug +" \n ---"
                +"areaId "+this.newKnowledge.areaId +" \n -- "
                +"version "+this.newKnowledge.version +" \n-- "
                +"title "+this.newKnowledge.title +" \n --"
                +"description "+this.newKnowledge.description +" \n -- "
                +"FixVer "+this.newKnowledge.fixVersion +" \n --";
          //console.log(l);
        return true;
      }else{
        return false;
      }
    }
  },
  data () {    
    return {
      loading:true,
      callFromSort:false,
      filtersList: false,
      documents:[],
      disabledBtn:false,
      deviceFamily:[],
      types:[],
      Areas:[],
      versions:[],
      selectoptions: ['list', 'of', 'options'],
      newKnowledge:{
        "deviceFamId":'',
        "deviceFamDetails":null,
        "typeId": '',
        typeDetails:null,
        "bug": '',
        "areaId": '',
        areaDetails:null,
        "version": "",
        versionDetails:null,
        "title": "",
		    "description": "",
        "wrkAround": "",
        "wrk_Around":false,
        
        "fixVersion": "",
        fixVersionDetails:null,
        documents:[],
	},
      description:'',
      statusOptions:[],
      statusFilter:null,
      Title:'',
      popupeditKnowledgeBase:false,
      popupcreateticket:false,
      textarea:'',

      selected:'',
      sortKeys: {
        name: 1,
        areaName: 1,
        statusName: 1,
        createdOn: -1,
        email: 1,
        roleName: 1
      },
      list: [],
      sortKey: {},
      email: '',
      users: '',
      page: 1,
      perPage: 25,
      totalpages: 0,
      perPeges: [25, 50, 75, 100],
      filters:{
			"title": "",
			"deviceFamIds": [],
			"typeIds": [],
			"areaIds": []
    },
    maxDate: new Date(),
    selected_createdDateRange :{
      startDate: null,
      endDate: null
    },
    autoApply: "",
    }
  },
  methods: {
    ckeckValue(obj , key){
      if(_.has( obj , key)){
        return true

      }else{
        return false;
      }


    },
    validateForm(){
      this.disabledBtn =false;
  //     newKnowledge:{
  //       "deviceFamId":'',
  //       "deviceFamDetails":null,
  //       "typeId": '',
  //       typeDetails:null,
  //       "bug": '',
  //       "areaId": '',
  //       areaDetails:null,
  //       "version": "",
  //       versionDetails:null,
  //       "title": "",
	// 	    "description": "",
  //       "wrkAround": "",
  //       "wrk_Around":false,
        
  //       "FixVer": "",
  //       fixVersionDetails:null,
  // }

      if(!this.newKnowledge.deviceFamId || this.newKnowledge.deviceFamId ==null || this.newKnowledge.deviceFamId=='' ){
        this.disabledBtn =false;
      }
      if(!this.newKnowledge.typeId){
        this.disabledBtn =true;
      }
      if(!this.newKnowledge.bug){
        this.disabledBtn =false;
      }
      if(!this.newKnowledge.areaId){
        this.disabledBtn =true;
      }
      if(!this.newKnowledge.version){
        this.disabledBtn =false;
      }
      if(!this.newKnowledge.wrkAround){
        this.disabledBtn =false;
      }
      if(!this.newKnowledge.FixVer){
        this.disabledBtn =false;
      }
      if(!this.newKnowledge.description){
        this.disabledBtn =true;
      }
    },
    changedDevice(item){
      this.newKnowledge.deviceFamId  ='';
      if(item !=null){
        this.newKnowledge.deviceFamId =item._id;
      }
      this.validateForm();
    },
    changedArea(item){
      this.newKnowledge.areaId ='';
      if(item !=null){
        this.newKnowledge.areaId =item._id;
      }
      this.validateForm();
    },
    changedType(item){
      this.newKnowledge.typeId ='';
      if(item !=null){
        this.newKnowledge.typeId =item._id;
      }
      this.validateForm();
    },
    changedVersion(item){
      this.newKnowledge.version ='';
      if(item !=null){
        this.newKnowledge.version =item._id;
      }
      this.validateForm();
    },
    changedFxVersion(item){
      this.newKnowledge.fixVersion ='';
      if(item !=null){
        this.newKnowledge.fixVersion =item._id;
      }
      this.validateForm();
    },
    check(e){
     if (e.target.checked) {
       this.newKnowledge.wrkAround ="Yes";

     }else{
       this.newKnowledge.wrkAround ="";
     }
     
    },
    getTypes(){
      let payload = {
        page: 1,
        perpage: 1000000000,
        category: 'type'
      }
      this.$store.dispatch("getTypes" ,payload).then((response) => {
      this.types = response;
     
    });

    },
    getDeviceFamily(){
      let postData ={
        page: 1,
        perpage: 10000000,
        category: 'device_family'
      }
      this.$store.dispatch("getDeviceFamily" ,postData).then((response) => {
      this.deviceFamily = response;
     
    });

    },
    
    getAreas(){
      let postData ={
        page: 1,
        perpage: 10000000,
        category: 'area'
      }
      this.$store.dispatch("getAreas" ,postData).then((response) => {
      this.Areas = _.filter(response, (obj)=> {
        return obj._id != 2;
      });
    });

    },
    getVersions(){
      let postData = {
      "filters":{ "title": ""},		
        "page": 1,
        "perpage": 1000000000
      }
      this.$store
        .dispatch("getSdkVersionsList", postData)
        .then((response) => {
          this.versions = response.list;
          
         
        })
        .catch((err) => {
          console.log(err);
          
          
        });
    },
    create(){
      this.newKnowledge.wrkAround = '';
      if(this.newKnowledge.wrk_Around){
        this.newKnowledge.wrkAround ='Yes';
      }
      this.$vs.loading()
      this.$store
        .dispatch("knowledgeBaseCreate", this.newKnowledge)
        .then((response) => {
         this.popupcreateticket = false
           this.$vs.loading.close();
           this.get_list();
          this.$vs.notify({
            title: "Success",
            text: response.message,
            position: "top-right",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((err) => {
          //console.log(err);
           
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: err.error_message.message,
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });

    },
    update(){
      this.newKnowledge.wrkAround = '';
      if(this.newKnowledge.wrk_Around){
        this.newKnowledge.wrkAround ='Yes';
      }
       this.$vs.loading();
     this.newKnowledge['knowledgeBaseId'] =this.newKnowledge['_id'];
      this.$store
        .dispatch("knowledgeBaseUpdate", this.newKnowledge)
        .then((response) => {
        this.popupcreateticket = false
           this.$vs.loading.close();
           this.get_list();
          this.$vs.notify({
            title: "Success",
            text: response.message,
            position: "top-right",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((err) => {
          //console.log(err);
           
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: err.error_message.message,
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });

    },
    getDetails(item,callFroEdit=false) {
     
      
      const payload = {
        knowledgeBaseId: item._id,
      };
    
      this.$store
        .dispatch("knowledgeBaseDetails", payload)
        .then((res) => {
         
          this.newKnowledge =res;
          this.newKnowledge.wrk_Around = false;
          if(this.newKnowledge.wrkAround =='Yes'){
              this.newKnowledge.wrk_Around =true;
          }
          if(callFroEdit){
            this.edit();
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
      add(){
        this.newKnowledge={
        "deviceFamId":'',
        "deviceFamDetails":null,
        "typeId": '',
        typeDetails:null,
        "bug": '',
        "areaId": '',
        areaDetails:null,
        "version": "",
        versionDetails:null,
        "title": "",
		    "description": "",
        "wrkAround": "",
        "wrk_Around":false,
        
        "fixVersion": "",
        fixVersionDetails:null,
        documents:[],
	}
        this.popupcreateticket = true;
        this.popupeditKnowledgeBase =false;
      },
      edit(){
         this.popupcreateticket = true;
         this.popupeditKnowledgeBase =true;
      },

    clearFilters(){
      this.filtersList =false;
      this.filters= {
			"title": "",
			"deviceFamIds": [],
			"typeIds": [],
			"areaIds": []
    }
    this.selected_createdDateRange  = {
      startDate: null,
      endDate: null
    },
    this.get_list();

    },
    onEnter() {
      this.filtersList =false;
      this.get_list();
    },
    get_list () {
     
      let postData = {
        filters:{"title": this.filters.title,	"deviceFamIds": [],	"typeIds": [],	"areaIds": [] ,"createdOnRange":[]},
        sorting: this.sortKey, //{"path": "name","order": -1	},
        page: this.page,
        perpage: this.perPage
      }
      if(this.filters.deviceFamIds.length>0){
        for( let i=0; i<this.filters.deviceFamIds.length;i++){
          postData.filters.deviceFamIds.push(this.filters.deviceFamIds[i]['_id'] )
        }
      }
      if(this.filters.typeIds.length>0){
        for( let i=0; i<this.filters.typeIds.length;i++){
          postData.filters.typeIds.push(this.filters.typeIds[i]['_id'] )
        }
      }
      if(this.filters.areaIds.length>0){
        for( let i=0; i<this.filters.areaIds.length;i++){
          postData.filters.areaIds.push(this.filters.areaIds[i]['_id'] )
        }
      }
      
      if(_.has(this.selected_createdDateRange ,'startDate' ) && this.selected_createdDateRange.startDate != null && this.selected_createdDateRange.endDate != null && _.has(this.selected_createdDateRange ,'endDate' )){
        postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['startDate']).format("YYYY-MM-DD"));
        postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['endDate']).format("YYYY-MM-DD"));
      }

      if(!this.callFromSort){
          this.list = []
           this.$vs.loading()
      }
       this.callFromSort  = false;
     
    
     this.loading =true;
      this.$store
        .dispatch('knowledgebaseList', postData)
        .then((response) => {
           this.$vs.loading.close();
           this.list = response.list
           this.totalpages = Math.ceil(response.totalCount / this.perPage)
            this.loading =false;
        })
        .catch((err) => {
           this.loading =false;
           this.$vs.loading.close();
          //console.log(err)
        })
    },
    change_perPage() {
        this.page = 1;
        
       this.callFromSort  = true;
     

        this.get_list();
      },
    sortMe(sort_key = "") {
  
    this.sortKey = { path: "createdOn", order: 1 };
    if (sort_key != "") {
      this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
      this.sortKey = {};

      this.sortKey["path"] = sort_key;
      this.sortKey["order"] = this.sortKeys[sort_key] == 1 ? -1 : 1;
      this.callFromSort  = true;
      this.get_list();
    }
  }, 
   upload(model){

      

          let temp_count = 0;
          let formData = new FormData();
          this.disabled_btn = true;          
          let mapper = model.map(
              item =>
              (item = {
                  name: item.name,
                  file: item.file ? item.file : null,
                  path: item.url ? item.url : "",
                  extn: item.name.split('.').pop(),
                  mimetype: item.type ? item.type : item.mimetype,
                  
              })
          );
          
          
              this.$vs.loading();
              if (mapper.length > 0) {
              mapper.forEach((doc, index) => {
                  formData.append("files", doc.file);
                  formData.append("secureType", "private");
                  this.$store.dispatch("uploadS3File", formData).then(response => {
                      temp_count++;
                      response.data.result.forEach(urlGenerated => {

                          
                            this.newKnowledge.documents.push(urlGenerated);
                          
                          if (temp_count >= mapper.length) {
                              this.disabled_btn = false;
                              this.$vs.loading.close();
                          }

                          doc.url = urlGenerated;
                          delete doc.file;
                          mapper[index] = doc;

                      });
                  });

              });
              model.splice(0, mapper.length, ...mapper);
          }
  
          
      }, 

    remove(index){
      this.newKnowledge.documents.splice(index ,1);

    }   
  },
  
  mounted () {

  this.getDeviceFamily();
  this.getTypes();
  this.getAreas();
  this.getVersions();
   this.get_list()

  
    /*this.$store.dispatch('getRoles').then((response) => {
      this.userRoles = response
      console.log('userRoles', this.userRoles)
    })
    //getuser_status
    this.$store.dispatch('getuser_status').then((response) => {
      this.status_list = response
      console.log('status_list', this.status_list)
    })*/
  },
  watch:{
    
    popupcreateticket:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }
        
    },
    
    
  }
}
</script>

<style lang="scss">
// .knowledge-base-jumbotron-content {
//     background-image: url('../../assets/images/pages/knowledge-base-cover.jpg');
//     background-size: cover;
// }
.not-data-table {
  display: none;
}
</style>
